import { useRef } from "react";
import { useParams } from "react-router-dom";
import { AmplitudeService } from "@analytics/Amplitude/AmplitudeService";
import { useTimerVolumeContext } from "@contexts/TimerVolumeContext";
import { GuestPomodoroService } from "../../../service/GuestPomodoroService";
import { PomodoroAnalyticsService } from "../../../service/PomodoroAnalyticsService";
import Pomodoro from "./Pomodoro";
import { useAlarmSoundOptions } from "./hooks/useAlarmSoundOptions";
import { useServerPomodoro } from "./hooks/useServerPomodoro";

interface GuestPomodoroProps {
    hidden: boolean;
    updateCompletedPomos: (numComplete: number) => void;
    onIsRunningChange?: (isRunning: boolean) => void;
}
export default function GuestPomodoro(props: GuestPomodoroProps) {
    const { roomId } = useParams<{ roomId: string }>();
    const amplitudeService = AmplitudeService.getInstance();

    const { groupTimerVolume, changeTimerVolume } = useTimerVolumeContext();

    const analyticsService = PomodoroAnalyticsService(amplitudeService);
    const pomodoroService = GuestPomodoroService(roomId, analyticsService);
    const alarmSoundOptions = useAlarmSoundOptions(pomodoroService);
    const timerAudioRef = useRef<HTMLAudioElement>(null);

    const { lastEvent, timerDisplayText, pomodoroSettingsInput, dispatchPomodoroSettingsInput } = useServerPomodoro({
        roomId,
        hidden: props.hidden,
        alarmSoundOptions,
        pomodoroService,
        audioRef: timerAudioRef,
        onPomodoroCountChange: props.updateCompletedPomos,
        onIsRunningChange: props.onIsRunningChange,
    });

    return (
        <Pomodoro
            hidden={props.hidden}
            stopTimerActionButtonLabel={""}
            canEditSettings={true}
            isRunning={lastEvent.isRunning ?? false}
            timerDisplayText={timerDisplayText}
            alarmSoundOptions={alarmSoundOptions}
            pomodoroService={pomodoroService}
            pomodoroSettingsInput={pomodoroSettingsInput}
            dispatchPomodoroSettingsInput={dispatchPomodoroSettingsInput}
            allowAutotransitionToggle={false}
            timerAudioRef={timerAudioRef}
            timerVolume={groupTimerVolume}
            setTimerVolume={(newVol: number) => changeTimerVolume("group", newVol)}
        />
    );
}
